import { PageController } from '@client/components/_core/layout/PageController';
import { AddPaymentDrawer } from '@client/components/claims/financials/payment-approval/AddPaymentDrawer';
import { ENABLE_CLAIM_PAYMENT_APPROVAL_FLAG } from '@shared/constants';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

/**
 * CUR-2672: the Add payment drawer, which creates a payment and sends it for approval in one Send. Under
 * payment approval, "Add payment" opens it instead of today's two-step form; a reserve's Shortcuts open
 * it with that reserve chosen.
 */
export const Route = createFileRoute('/console/$orgId/claims/details/$id/financials/payments/add')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Add payment',
        },
        // Hidden with the rest of payment approval; the server answers NOT_FOUND while it is off.
        featureFlag: ENABLE_CLAIM_PAYMENT_APPROVAL_FLAG,
    },
    // A reserve's Shortcuts open the drawer with that reserve chosen. The router reads their link's id as
    // a string, and one typed into the address bar as a number. Anything else is dropped, so the drawer
    // opens with no reserve chosen.
    validateSearch: zodValidator(
        z.object({
            reserveId: z
                .union([z.string().regex(/^\d+$/), z.number().int().nonnegative().transform(String)])
                .optional()
                .catch(undefined),
        }),
    ),
    component: RouteComponent,
});

function RouteComponent() {
    const { id: claimId } = Route.useParams();
    const { reserveId } = Route.useSearch();
    return (
        <PageController route={Route}>
            <AddPaymentDrawer
                claimId={claimId}
                initialReserveId={reserveId === undefined ? undefined : BigInt(reserveId)}
            />
            {/* Add contact and New supplier, opened from the payee list, over the drawer. */}
            <Outlet />
        </PageController>
    );
}
